( function() {
	document.addEventListener( 'DOMContentLoaded', function () {
		var navbarEle = document.querySelector( '.navbar' );
		if( !navbarEle ) { return; }

		const event = new CustomEvent( 'navbarChanged' );

		function isSmall() {
			if( menuWrapperEle.offsetWidth === window.innerWidth || getComputedStyle( menuWrapperEle ).opacity === 0 ) {
				return true;
			}

			return false;
		}

		/////
		///// Sticky Behavior
		/////
		const observer = new IntersectionObserver( function( entry ) {
			if( entry[0].intersectionRatio < 1 ) {
				navbarEle.classList.add( 'navbar--pinned' );
				navbarEle.dispatchEvent( event );
			} else {
				navbarEle.classList.remove( 'navbar--pinned' );
			}
		}, { threshold: [1] } );
		observer.observe( navbarEle.querySelector( '.navbar__pin-trigger' ) );

		/////
		///// Hamburger Menu Toggle Animation
		/////
		var bodyEle = document.querySelector( 'body' );
		var menuWrapperEle = navbarEle.querySelector( '.navbar-collapse' );

		$( menuWrapperEle ).on( 'hidden.bs.collapse', function ( e ) { // Jquery required to listen to event
			if( e.target === menuWrapperEle ) {
				bodyEle.classList.remove( 'modal-open' );
			}
		} ).on( 'shown.bs.collapse', function( e ) {
			if( ( e.target === menuWrapperEle ) && isSmall() ) {
				bodyEle.classList.add( 'modal-open' );
			}
		} ).on( 'show.bs.collapse', function( e ) {
			if( e.target !== menuWrapperEle ) {
				// A child is collapsing - not the toggle itself
				return;
			}
			// Wait for Bootstrap to change the classes, then add ours to support the transition
			setTimeout( function() {
				menuWrapperEle.classList.add( 'navbar-collapse--fade-in' );
				navbarEle.classList.add( 'navbar--open' );
				navbarEle.dispatchEvent( event );
			}, 1 );
		} ).on( 'hide.bs.collapse', function( e ) {
			if( e.target !== menuWrapperEle ) {
				// A child is collapsing - not the toggle itself
				return;
			}
			menuWrapperEle.classList.remove( 'navbar-collapse--fade-in' );
			navbarEle.classList.remove( 'navbar--open' );
			navbarEle.dispatchEvent( event );
		} );

		/////
		///// Hover to open dropdowns
		/////
		var dropdownsEles = menuWrapperEle.querySelectorAll( '.dropdown' );

		dropdownsEles.forEach( function ( dropdown ) {
			var dropdownToggle = dropdown.querySelector( '.navbar__dropdown-toggle' );
			var dropdownPanel = dropdown.querySelector( '.navbar__dropdown' );

			dropdownToggle.addEventListener( 'mouseover', openDropdown );

			dropdownToggle.addEventListener( 'focusin', openDropdown );

			dropdown.addEventListener( 'mouseout', closeDropdown );

			dropdown.addEventListener( 'focusout', closeDropdown );

			/////
			///// Individual Dropdown Animations
			/////
			$( dropdownPanel ).on( 'show.bs.collapse', function() {
				var dropdownEle = this;
				// Wait for Bootstrap to change the classes, then add ours to support the transition
				setTimeout( function() {
					dropdownEle.classList.add( 'navbar__dropdown--fade-in' );
				}, 1 );
			} );

			$( dropdownPanel ).on( 'hide.bs.collapse', function( e ) {
				if( e.target !== dropdownPanel ) {
					// A child is collapsing - not the toggle itself
					return;
				}

				e.target.classList.remove( 'navbar__dropdown--fade-in' );
			} );
		} );

		function openDropdown( e ) {
			var currDropdown = this.closest( '.dropdown' );
			if( !isSmall() && ( currDropdown.contains( e.target ) || currDropdown === e.target ) ) {
				$( currDropdown.querySelector( '.navbar__dropdown' ) ).collapse( 'show' );
			}
		}

		function closeDropdown( e ) {
			if( !isSmall() && ( !this.contains( e.relatedTarget ) && this !== e.relatedTarget ) ) {
				$( this.querySelector( '.navbar__dropdown' ) ).collapse( 'hide' );
			}
		}
	} );
} )();